import { render } from "./ConsumptionGauge.vue?vue&type=template&id=4ecd9fd6"
import script from "./ConsumptionGauge.vue?vue&type=script&lang=js"
export * from "./ConsumptionGauge.vue?vue&type=script&lang=js"

import "./ConsumptionGauge.vue?vue&type=style&index=0&id=4ecd9fd6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__